// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","footerLabel":"Footer_footerLabel__2EqvQ"};